// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-hotkey {
  align-items: center;
  display: inline-flex;
  gap: 4px;
  vertical-align: middle;
  line-height: 1.5;
}
:where(.vuetify-styles) .v-hotkey--disabled {
  opacity: 0.26;
}
:where(.vuetify-styles) .v-hotkey--inline {
  max-height: 1lh;
  vertical-align: baseline;
  font-size: 1em;
  line-height: inherit;
}
:where(.vuetify-styles) .v-hotkey__prefix {
  opacity: var(--v-medium-emphasis-opacity);
  font-weight: normal;
  vertical-align: baseline;
}
:where(.vuetify-styles) .v-hotkey__suffix {
  opacity: var(--v-medium-emphasis-opacity);
  font-weight: normal;
  vertical-align: baseline;
}
:where(.vuetify-styles) .v-hotkey--contained .v-hotkey__contained-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0.2rem 4px;
  box-sizing: border-box;
  background: unset;
  box-shadow: unset;
  min-height: 1em;
  font-size: 0.75rem;
  line-height: 1.5;
}
:where(.vuetify-styles) .v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__prefix, :where(.vuetify-styles) .v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__suffix {
  opacity: var(--v-high-emphasis-opacity);
}
:where(.vuetify-styles) .v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__prefix {
  margin-right: 2px;
}
:where(.vuetify-styles) .v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__suffix {
  margin-left: 2px;
}
:where(.vuetify-styles) .v-hotkey--contained .v-hotkey__divider {
  opacity: var(--v-medium-emphasis-opacity);
  font-size: inherit;
}
:where(.vuetify-styles) .v-hotkey--contained .v-hotkey__combination {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
:where(.vuetify-styles) .v-hotkey--contained.v-hotkey--inline .v-hotkey__contained-wrapper.v-kbd {
  align-self: baseline;
  align-items: baseline;
  font-size: 1em;
  line-height: inherit;
  padding: 1px 4px 0;
  gap: 2px;
  margin-left: 0;
  margin-right: 0;
}
:where(.vuetify-styles) .v-hotkey--contained.v-hotkey--inline .v-hotkey__divider {
  font-size: 1em;
  align-self: baseline;
}
:where(.vuetify-styles) .v-hotkey--contained.v-hotkey--inline .v-hotkey__combination {
  gap: 2px;
  align-items: baseline;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd {
  min-height: unset;
  font-size: 0.75rem;
  line-height: 1.5;
  padding: 0.2rem;
  min-width: 1.5em;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-plain, :where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-outlined, :where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-text, :where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-tonal {
  background: transparent;
  color: inherit;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-plain {
  opacity: 0.62;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-plain:focus, :where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-plain:hover {
  opacity: 1;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-plain .v-hotkey__overlay {
  display: none;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-elevated, :where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-flat {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-elevated {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-outlined {
  border: thin solid currentColor;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-text .v-hotkey__overlay {
  background: currentColor;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd--variant-tonal .v-hotkey__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-hotkey__key.v-kbd .v-hotkey__underlay {
  position: absolute;
}
:where(.vuetify-styles) .v-hotkey__key-symbol.v-kbd {
  line-height: normal;
  font-size: 1em;
}
:where(.vuetify-styles) .v-hotkey__key-icon .v-icon {
  min-width: unset;
}
:where(.vuetify-styles) .v-hotkey__key-icon .v-icon:has(svg) {
  max-width: 0.75rem;
}
:where(.vuetify-styles) .v-hotkey__key-icon .v-icon:not(:has(svg)) {
  font-size: 0.75rem;
  line-height: inherit;
  height: inherit;
}
:where(.vuetify-styles) .v-hotkey__key--nested {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  display: inline-flex;
  align-items: center;
  min-width: auto;
  min-height: auto;
  align-self: baseline;
}
:where(.vuetify-styles) .v-hotkey__key--nested.v-hotkey__key-icon {
  align-self: center;
}
:where(.vuetify-styles) .v-hotkey__divider {
  align-items: center;
  display: inline-flex;
  opacity: var(--v-medium-emphasis-opacity);
  font-size: 1em;
}
:where(.vuetify-styles) .v-hotkey__combination {
  display: flex;
  gap: 2px;
}
:where(.vuetify-styles) .v-hotkey--inline .v-hotkey__key {
  align-self: center;
  padding: 1px 4px 0;
  min-width: 20px;
  height: calc(1lh - 2px);
  line-height: calc(1lh - 2px);
}
:where(.vuetify-styles) .v-hotkey--inline .v-hotkey__key-icon.v-kbd {
  padding-block: 0;
}
:where(.vuetify-styles) .v-hotkey--inline .v-hotkey__key-icon .v-icon {
  width: min-content;
  min-width: fit-content;
  max-height: calc(1ex + 2px);
}
:where(.vuetify-styles) .v-hotkey--inline .v-hotkey__key-icon .v-icon .v-icon__svg {
  height: 100%;
  width: unset;
}
:where(.vuetify-styles) .v-hotkey--inline .v-hotkey__combination {
  align-items: baseline;
  gap: 1px;
}
:where(.vuetify-styles) .v-hotkey--inline .v-hotkey__divider {
  font-size: 1em;
}
:where(.vuetify-styles) .v-hotkey--inline .v-hotkey__prefix, :where(.vuetify-styles) .v-hotkey--inline .v-hotkey__suffix {
  align-self: baseline;
  font-size: inherit;
}
:where(.vuetify-styles) .v-hotkey--variant-elevated .v-hotkey__key.v-kbd {
  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-hotkey--variant-flat .v-hotkey__key.v-kbd {
  box-shadow: none;
}
:where(.vuetify-styles) .v-hotkey--variant-outlined .v-hotkey__key.v-kbd {
  background: none;
}
:where(.vuetify-styles) .v-hotkey--variant-outlined .v-hotkey__key.v-kbd {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-hotkey--variant-text .v-hotkey__key.v-kbd {
  background: transparent !important;
  border: none !important;
  padding-inline: 0;
  min-width: auto;
}
:where(.vuetify-styles) .v-hotkey--variant-text .v-hotkey__key.v-kbd {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-hotkey--variant-text .v-hotkey__combination {
  gap: 1px;
}
:where(.vuetify-styles) .v-hotkey--variant-tonal .v-hotkey__key.v-kbd {
  border: unset;
  box-shadow: unset;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VHotkey/VHotkey.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,uOAAuO;AACzO;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,iBAAiB;AACnB","sourcesContent":[".v-hotkey {\n  align-items: center;\n  display: inline-flex;\n  gap: 4px;\n  vertical-align: middle;\n  line-height: 1.5;\n}\n.v-hotkey--disabled {\n  opacity: 0.26;\n}\n.v-hotkey--inline {\n  max-height: 1lh;\n  vertical-align: baseline;\n  font-size: 1em;\n  line-height: inherit;\n}\n.v-hotkey__prefix {\n  opacity: var(--v-medium-emphasis-opacity);\n  font-weight: normal;\n  vertical-align: baseline;\n}\n.v-hotkey__suffix {\n  opacity: var(--v-medium-emphasis-opacity);\n  font-weight: normal;\n  vertical-align: baseline;\n}\n.v-hotkey--contained .v-hotkey__contained-wrapper {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0.2rem 4px;\n  box-sizing: border-box;\n  background: unset;\n  box-shadow: unset;\n  min-height: 1em;\n  font-size: 0.75rem;\n  line-height: 1.5;\n}\n.v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__prefix, .v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__suffix {\n  opacity: var(--v-high-emphasis-opacity);\n}\n.v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__prefix {\n  margin-right: 2px;\n}\n.v-hotkey--contained .v-hotkey__contained-wrapper .v-hotkey__suffix {\n  margin-left: 2px;\n}\n.v-hotkey--contained .v-hotkey__divider {\n  opacity: var(--v-medium-emphasis-opacity);\n  font-size: inherit;\n}\n.v-hotkey--contained .v-hotkey__combination {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n.v-hotkey--contained.v-hotkey--inline .v-hotkey__contained-wrapper.v-kbd {\n  align-self: baseline;\n  align-items: baseline;\n  font-size: 1em;\n  line-height: inherit;\n  padding: 1px 4px 0;\n  gap: 2px;\n  margin-left: 0;\n  margin-right: 0;\n}\n.v-hotkey--contained.v-hotkey--inline .v-hotkey__divider {\n  font-size: 1em;\n  align-self: baseline;\n}\n.v-hotkey--contained.v-hotkey--inline .v-hotkey__combination {\n  gap: 2px;\n  align-items: baseline;\n}\n.v-hotkey__key.v-kbd {\n  min-height: unset;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  padding: 0.2rem;\n  min-width: 1.5em;\n}\n.v-hotkey__key.v-kbd--variant-plain, .v-hotkey__key.v-kbd--variant-outlined, .v-hotkey__key.v-kbd--variant-text, .v-hotkey__key.v-kbd--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-hotkey__key.v-kbd--variant-plain {\n  opacity: 0.62;\n}\n.v-hotkey__key.v-kbd--variant-plain:focus, .v-hotkey__key.v-kbd--variant-plain:hover {\n  opacity: 1;\n}\n.v-hotkey__key.v-kbd--variant-plain .v-hotkey__overlay {\n  display: none;\n}\n.v-hotkey__key.v-kbd--variant-elevated, .v-hotkey__key.v-kbd--variant-flat {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-hotkey__key.v-kbd--variant-elevated {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-hotkey__key.v-kbd--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-hotkey__key.v-kbd--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-hotkey__key.v-kbd--variant-text .v-hotkey__overlay {\n  background: currentColor;\n}\n.v-hotkey__key.v-kbd--variant-tonal .v-hotkey__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.v-hotkey__key.v-kbd .v-hotkey__underlay {\n  position: absolute;\n}\n.v-hotkey__key-symbol.v-kbd {\n  line-height: normal;\n  font-size: 1em;\n}\n.v-hotkey__key-icon .v-icon {\n  min-width: unset;\n}\n.v-hotkey__key-icon .v-icon:has(svg) {\n  max-width: 0.75rem;\n}\n.v-hotkey__key-icon .v-icon:not(:has(svg)) {\n  font-size: 0.75rem;\n  line-height: inherit;\n  height: inherit;\n}\n.v-hotkey__key--nested {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  min-width: auto;\n  min-height: auto;\n  align-self: baseline;\n}\n.v-hotkey__key--nested.v-hotkey__key-icon {\n  align-self: center;\n}\n.v-hotkey__divider {\n  align-items: center;\n  display: inline-flex;\n  opacity: var(--v-medium-emphasis-opacity);\n  font-size: 1em;\n}\n.v-hotkey__combination {\n  display: flex;\n  gap: 2px;\n}\n.v-hotkey--inline .v-hotkey__key {\n  align-self: center;\n  padding: 1px 4px 0;\n  min-width: 20px;\n  height: calc(1lh - 2px);\n  line-height: calc(1lh - 2px);\n}\n.v-hotkey--inline .v-hotkey__key-icon.v-kbd {\n  padding-block: 0;\n}\n.v-hotkey--inline .v-hotkey__key-icon .v-icon {\n  width: min-content;\n  min-width: fit-content;\n  max-height: calc(1ex + 2px);\n}\n.v-hotkey--inline .v-hotkey__key-icon .v-icon .v-icon__svg {\n  height: 100%;\n  width: unset;\n}\n.v-hotkey--inline .v-hotkey__combination {\n  align-items: baseline;\n  gap: 1px;\n}\n.v-hotkey--inline .v-hotkey__divider {\n  font-size: 1em;\n}\n.v-hotkey--inline .v-hotkey__prefix, .v-hotkey--inline .v-hotkey__suffix {\n  align-self: baseline;\n  font-size: inherit;\n}\n.v-hotkey--variant-elevated .v-hotkey__key.v-kbd {\n  box-shadow: 0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-hotkey--variant-flat .v-hotkey__key.v-kbd {\n  box-shadow: none;\n}\n.v-hotkey--variant-outlined .v-hotkey__key.v-kbd {\n  background: none;\n}\n.v-hotkey--variant-outlined .v-hotkey__key.v-kbd {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-hotkey--variant-text .v-hotkey__key.v-kbd {\n  background: transparent !important;\n  border: none !important;\n  padding-inline: 0;\n  min-width: auto;\n}\n.v-hotkey--variant-text .v-hotkey__key.v-kbd {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-hotkey--variant-text .v-hotkey__combination {\n  gap: 1px;\n}\n.v-hotkey--variant-tonal .v-hotkey__key.v-kbd {\n  border: unset;\n  box-shadow: unset;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
